import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;

//  Async thunk for daily task list
export const fetchDailyTaskList = createAsyncThunk(
  "Day/fetchDailyTaskList",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/ShowDailyList/${id}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

//  Async thunk for Employee Daily Report
export const EmpDayReport = createAsyncThunk(
  "Day/createDayReport",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DayReport/DayReportCreate`,
        formData,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

//  Async thunk for Fetch Employee Daily Report
export const fetchDayReportByEmpId = createAsyncThunk(
  "Day/fetchDayReportByEmpId",
  async (params, { rejectWithValue }) => {
    try {
      const { memberId, page, limit } = params;
      const response = await axios.get(
        `${BaseUrl}/DayReport/DayReportFind/${memberId}`,
        { params: { page, limit } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

// ✅ New thunk for All Daily Reports
export const fetchAllDailyReports = createAsyncThunk(
  "Day/fetchAllDailyReports",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/DayReport/DayReportFindid`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

// ✅ New thunk for All Daily Reports
export const fetchAllTaskReports = createAsyncThunk(
  "Day/fetchAllTaskReports",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/Complatecallreport`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const ComplateRunningreport = createAsyncThunk(
  "ConplainController/ComplateRunningreport",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/ComplateRunningreport`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const projectModuleType = createAsyncThunk(
  "ConplainController/projectModuleType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/projectModuleType`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const DayReportFindforcheq = createAsyncThunk(
  "DayReport/DayReportFindforcheq",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DayReport/DayReportFindforcheq`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const DayReportFindforcheqReport = createAsyncThunk(
  "DayReport/DayReportFindforcheqReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DayReport/DayReportFindforcheqReport`,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const FindIdDayReportCreate = createAsyncThunk(
  "DayReport/FindIdDayReportCreate",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DayReport/FindIdDayReportCreate/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const DayReportFindforcheqall = createAsyncThunk(
  "DayReport/DayReportFindforcheqall",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DayReport/DayReportFindforcheqall`,
        { params }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const DaySlice = createSlice({
  name: "day",
  initialState: {
    DailyTaskList: null,
    DailyTaskLoading: false,
    DailyTaskError: null,

    CreateDayReport: null,
    CreateDayReportLoading: false,
    CreateDayReportError: null,

    DayReportData: null,
    DayReportsLoading: false,
    DayReportsError: null,

    // ✅ New state for All Daily Reports
    AllDailyReportData: null,
    AllDailyReportsLoading: false,
    AllDailyReportsError: null,

    // ✅ New state for All Daily Reports
    AllTaskReportData: null,
    AllTaskReportsLoading: false,
    AllTaskReportsError: null,

    ComplateRunningreportData: null,
    ComplateRunningreportLoading: false,
    ComplateRunningreportError: null,

    projectModuleTypeData: null,
    projectModuleTypeLoading: false,
    projectModuleTypetError: null,

    DayReportFindforcheqData: null,
    DayReportFindforcheqLoading: false,
    DayReportFindforcheqError: null,

    DayReportFindforcheqReportData: null,
    DayReportFindforcheqReportLoading: false,
    DayReportFindforcheqReportError: null,

    FindIdDayReportCreateData: null,
    FindIdDayReportCreateLoading: false,
    FindIdDayReportCreateError: null,

    DayReportFindforcheqallData: null,
    DayReportFindforcheqallLoading: false,
    DayReportFindforcheqallError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Daily Task List
      .addCase(fetchDailyTaskList.pending, (state) => {
        state.DailyTaskLoading = true;
        state.DailyTaskError = null;
      })
      .addCase(fetchDailyTaskList.fulfilled, (state, action) => {
        state.DailyTaskLoading = false;
        state.DailyTaskList = action.payload;
      })
      .addCase(fetchDailyTaskList.rejected, (state, action) => {
        state.DailyTaskLoading = false;
        state.DailyTaskError = action.payload;
      })

      // Create Day Report
      .addCase(EmpDayReport.pending, (state) => {
        state.CreateDayReportLoading = true;
        state.CreateDayReport = null;
        state.CreateDayReportError = null;
      })
      .addCase(EmpDayReport.fulfilled, (state, action) => {
        state.CreateDayReportLoading = false;
        state.CreateDayReport = action.payload;
      })
      .addCase(EmpDayReport.rejected, (state, action) => {
        state.CreateDayReportLoading = false;
        state.CreateDayReportError = action.payload;
      })

      // Fetch day reports
      .addCase(fetchDayReportByEmpId.pending, (state) => {
        state.DayReportsLoading = true;
        state.DayReportsError = null;
      })
      .addCase(fetchDayReportByEmpId.fulfilled, (state, action) => {
        state.DayReportsLoading = false;
        state.DayReportData = action.payload;
      })
      .addCase(fetchDayReportByEmpId.rejected, (state, action) => {
        state.DayReportsLoading = false;
        state.DayReportsError = action.payload;
      })

      // ✅ Fetch All Daily Reports
      .addCase(fetchAllDailyReports.pending, (state) => {
        state.AllDailyReportsLoading = true;
        state.AllDailyReportsError = null;
      })
      .addCase(fetchAllDailyReports.fulfilled, (state, action) => {
        state.AllDailyReportsLoading = false;
        state.AllDailyReportData = action.payload;
      })
      .addCase(fetchAllDailyReports.rejected, (state, action) => {
        state.AllDailyReportsLoading = false;
        state.AllDailyReportsError = action.payload;
      })

      // ✅ Fetch All Task Reports
      .addCase(fetchAllTaskReports.pending, (state) => {
        state.AllTaskReportsLoading = true;
        state.AllTaskReportsError = null;
      })
      .addCase(fetchAllTaskReports.fulfilled, (state, action) => {
        state.AllTaskReportsLoading = false;
        state.AllTaskReportData = action.payload;
      })
      .addCase(fetchAllTaskReports.rejected, (state, action) => {
        state.AllTaskReportsLoading = false;
        state.AllTaskReportsError = action.payload;
      })

      .addCase(ComplateRunningreport.pending, (state) => {
        state.ComplateRunningreportLoading = true;
        state.ComplateRunningreportError = null;
      })
      .addCase(ComplateRunningreport.fulfilled, (state, action) => {
        state.ComplateRunningreportLoading = false;
        state.ComplateRunningreportData = action.payload;
      })
      .addCase(ComplateRunningreport.rejected, (state, action) => {
        state.ComplateRunningreportLoading = false;
        state.ComplateRunningreportError = action.payload;
      })

      .addCase(DayReportFindforcheq.pending, (state) => {
        state.DayReportFindforcheqLoading = true;
        state.DayReportFindforcheqError = null;
      })
      .addCase(DayReportFindforcheq.fulfilled, (state, action) => {
        state.DayReportFindforcheqLoading = false;
        state.DayReportFindforcheqData = action.payload;
      })
      .addCase(DayReportFindforcheq.rejected, (state, action) => {
        state.DayReportFindforcheqLoading = false;
        state.DayReportFindforcheqError = action.payload;
      })

      .addCase(DayReportFindforcheqReport.pending, (state) => {
        state.DayReportFindforcheqReportLoading = true;
        state.DayReportFindforcheqReportError = null;
      })
      .addCase(DayReportFindforcheqReport.fulfilled, (state, action) => {
        state.DayReportFindforcheqReportLoading = false;
        state.DayReportFindforcheqReportData = action.payload;
      })
      .addCase(DayReportFindforcheqReport.rejected, (state, action) => {
        state.DayReportFindforcheqReportLoading = false;
        state.DayReportFindforcheqReportError = action.payload;
      })

      .addCase(FindIdDayReportCreate.pending, (state) => {
        state.FindIdDayReportCreateLoading = true;
        state.FindIdDayReportCreateError = null;
      })
      .addCase(FindIdDayReportCreate.fulfilled, (state, action) => {
        state.FindIdDayReportCreateLoading = false;
        state.FindIdDayReportCreateData = action.payload;
      })
      .addCase(FindIdDayReportCreate.rejected, (state, action) => {
        state.FindIdDayReportCreateLoading = false;
        state.FindIdDayReportCreateError = action.payload;
      })

      .addCase(projectModuleType.pending, (state) => {
        state.projectModuleTypeLoading = true;
        state.projectModuleTypetError = null;
      })
      .addCase(projectModuleType.fulfilled, (state, action) => {
        state.projectModuleTypeLoading = false;
        state.projectModuleTypeData = action.payload;
      })
      .addCase(projectModuleType.rejected, (state, action) => {
        state.projectModuleTypeLoading = false;
        state.projectModuleTypetError = action.payload;
      })

      .addCase(DayReportFindforcheqall.pending, (state) => {
        state.DayReportFindforcheqallLoading = true;
        state.DayReportFindforcheqallError = null;
      })
      .addCase(DayReportFindforcheqall.fulfilled, (state, action) => {
        state.DayReportFindforcheqallLoading = false;
        state.DayReportFindforcheqallData = action.payload;
      })
      .addCase(DayReportFindforcheqall.rejected, (state, action) => {
        state.DayReportFindforcheqallLoading = false;
        state.DayReportFindforcheqallError = action.payload;
      });
  },
});

// Export the reducer
export default DaySlice.reducer;
